(() => {
  'use strict';

  const KEY = 'ksWishlistV1';

  function cleanPrice(value) {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    const money = text.match(/(?:₹|Rs\.?)\s*[\d,]+(?:\.\d{1,2})?/i);
    if (money) return money[0].replace(/\s+/g, ' ').trim();
    const fallback = text.match(/[\d,]+(?:\.\d{1,2})?/);
    return fallback ? fallback[0] : '';
  }

  function sanitizeStorage() {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return;
      let changed = false;
      const next = raw.map(item => {
        if (!item || typeof item !== 'object') return item;
        const price = cleanPrice(item.price);
        if (price !== (item.price || '')) changed = true;
        return {...item, price};
      });
      if (changed) localStorage.setItem(KEY, JSON.stringify(next));
    } catch (_) {}
  }

  function sanitizeDrawer() {
    document.querySelectorAll('.ks-wishlist-item-price').forEach(el => {
      const cleaned = cleanPrice(el.textContent);
      if (cleaned && cleaned !== el.textContent.trim()) el.textContent = cleaned;
    });
  }

  function run() {
    sanitizeStorage();
    sanitizeDrawer();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run, {once:true})
    : run();

  document.addEventListener('click', event => {
    if (event.target.closest('.ks-wishlist-toggle,.ks-wishlist-remove,.ks-wishlist-header')) {
      setTimeout(run, 60);
      setTimeout(run, 180);
    }
  }, true);

  window.addEventListener('storage', event => {
    if (event.key === KEY) run();
  });

  const observer = new MutationObserver(mutations => {
    if (mutations.some(m => {
      const el = m.target?.nodeType === 1 ? m.target : m.target?.parentElement;
      return el && (el.closest?.('#KSWishlistDrawer') || el.querySelector?.('.ks-wishlist-item-price'));
    })) {
      sanitizeDrawer();
    }
  });

  const startObserver = () => observer.observe(document.body, {childList:true, subtree:true, characterData:true});
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, {once:true});
})();